import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function Navbar() {
  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center group" data-testid="nav-logo">
          <img
            src="/logo.png"
            alt="Tombs Electronic Repair"
            className="h-12 sm:h-14 w-auto object-contain group-hover:opacity-90 transition-opacity"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8 font-mono text-xs tracking-[0.15em] uppercase">
          <a href="#services" data-testid="nav-services" className="text-zinc-400 hover:text-white transition-colors">
            Services
          </a>
          <a href="#pricing" data-testid="nav-pricing" className="text-zinc-400 hover:text-white transition-colors">
            Pricing
          </a>
          <a href="#process" data-testid="nav-process" className="text-zinc-400 hover:text-white transition-colors">
            Process
          </a>
          <a href="#gallery" data-testid="nav-gallery" className="text-zinc-400 hover:text-white transition-colors">
            Gallery
          </a>
          <a href="#reviews" data-testid="nav-reviews" className="text-zinc-400 hover:text-white transition-colors">
            Reviews
          </a>
          <a href="#track" data-testid="nav-track" className="text-zinc-400 hover:text-white transition-colors">
            Track
          </a>
          <a href="#contact" data-testid="nav-contact" className="text-zinc-400 hover:text-white transition-colors">
            Contact
          </a>
        </nav>

        <a href="#booking" data-testid="nav-cta-book">
          <Button className="bg-[#0055FF] hover:bg-blue-600 text-white rounded-md font-semibold">
            Book Repair
          </Button>
        </a>
      </div>
    </header>
  );
}
